import React, { useContext, useEffect } from "react";
import { VariantContextData } from "../variants/VariantBuilderContext";
import useAssignments, { displayName } from "./hooks/useAssignments";
import useDropdown from "./hooks/useDropdown";
import VariantBuilderAssignmentDropdown from "./VariantBuilderAssignmentDropdown";

const VariantBuilderToolbarInvite = (props) => {
  const [contextData = {}] = useContext(VariantContextData) || [];
  const canAssign = props.can_edit_campaign === true;

  const assignments = useAssignments({
    cta: props.cta,
    website: props.website,
    canAssign,
  });
  const { assigned, loadAssignments, setQuery } = assignments;

  useEffect(() => {
    loadAssignments();
  }, []);

  const { open, setOpen, buttonRef, dropdownRef } = useDropdown({
    onClose: () => setQuery(""),
  });

  const previewUsers = [
    props.current_user,
    ...assigned.filter((u) => u.id !== props.current_user.id),
  ];
  const visiblePreviewUsers = previewUsers.slice(0, 3);
  const overflowCount = Math.max(0, previewUsers.length - 3);

  return (
    <React.Fragment>
      <div
        ref={buttonRef}
        className={`grid grid-flow-col auto-cols-auto justify-center mr-5 relative ${
          props.page ? "pt-2" : ""
        }`}
      >
        <div className="pt-1 order-first z-20">
          <a
            onClick={() => setOpen(!open)}
            title="Assign users"
            className="cursor-pointer"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
            >
              <rect
                x="1"
                y="1"
                width="26"
                height="26"
                rx="13"
                fill={!contextData.dark_mode ? "#EFEFEF" : "#1D1F2D"}
              />
              <rect
                x="1"
                y="1"
                width="26"
                height="26"
                rx="13"
                stroke={!contextData.dark_mode ? "white" : "black"}
                strokeLinecap="round"
              />
              <path
                d="M14 9.125L14 18.875M18.875 14L9.125 14"
                stroke={!contextData.dark_mode ? "#959595" : "#A1A8C1"}
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
          </a>
        </div>
        {visiblePreviewUsers.map((user, index) => (
          <div
            key={user.id}
            className={`pt-1 -ml-3 ${index === 0 ? "order-1 z-10" : "order-last"}`}
          >
            <a
              onClick={() => setOpen(true)}
              title={displayName(user)}
              className="cursor-pointer"
            >
              <div className="!w-[25px] !h-[25px] mt-[1px] overflow-hidden rounded-full relative">
                <img src={user.avatar} className="w-full h-auto" />
              </div>
            </a>
          </div>
        ))}
        {overflowCount > 0 && (
          <div className="pt-1 -ml-3 order-last">
            <a onClick={() => setOpen(true)} className="cursor-pointer">
              <div className="!w-[25px] !h-[25px] mt-[1px] flex items-center justify-center rounded-full bg-slate-200 dark:bg-slate-800 text-slate-600 dark:text-gray-300 text-[10px] font-semibold">
                +{overflowCount}
              </div>
            </a>
          </div>
        )}

        {open && (
          <VariantBuilderAssignmentDropdown
            ref={dropdownRef}
            {...assignments}
            canAssign={canAssign}
            showInviteLink={true}
            onInvite={() => {
              setOpen(false);
              $("#new-user").modal("show");
            }}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default VariantBuilderToolbarInvite;
